import { css, cx } from "@emotion/css";
import { fontSize, fontWeight, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
type Size = "small" | "medium" | "large";
type Weight = "normal" | "bold";
export type LinkProps = {
    href: string;
    children: string;
    leadingIcon?: React.ReactNode;
    trailingIcon?: React.ReactNode;
    openInNewTab?: boolean;
    size?: Size;
    weight?: Weight;
    onClick?: () => void;
};
export function Link({ href, children, leadingIcon, trailingIcon, openInNewTab = false, size, weight = "normal", onClick }: LinkProps) {
    return (<a className={cx(styles.link, { [styles.bold]: weight === "bold" }, styles.fontSize(size))} href={href} target={openInNewTab ? "_blank" : undefined} rel={openInNewTab ? "noreferrer noopener" : undefined} onClick={onClick}>
            {leadingIcon ? <span>{leadingIcon}</span> : null}
            {children}
            {trailingIcon ? <span>{trailingIcon}</span> : null}
        </a>);
}
const styles = {
    link: css({
        display: "inline-flex",
        alignItems: "center",
        gap: space[4],
        font: text.body.regular.medium,
        color: themeTokens.color.text.link.default,
        textDecoration: "none",
        "&:hover": {
            color: themeTokens.color.text.link.hover,
        },
    }),
    bold: css({
        fontWeight: fontWeight[700],
    }),
    fontSize: (size?: Size) => {
        switch (size) {
            case undefined:
                // allow Link to inherit font size from parent
                return undefined;
            case "small":
                return css({
                    fontSize: fontSize.small,
                });
            case "medium":
                return css({
                    fontSize: fontSize.medium,
                });
            case "large":
                return css({
                    fontSize: fontSize.base,
                });
        }
    },
};
